/**
 * 转换点几何坐标.
 * @param {Array} coordinates - 点的几何数组
 * @param {Function} convertFunc - 点坐标转换函数
 * @returns {Array} - 转换后的点几何数组
 */
function _convertPoint(coordinates, convertFunc) {
    return convertFunc(coordinates);
}

/**
 * 转换线几何坐标.
 * @param {Array} coordinates - 线的几何数组
 * @param {Function} convertFunc - 点坐标转换函数
 * @returns {Array} - 转换后的线几何数组
 */
function _convertLineString(coordinates, convertFunc) {
    const newCoordinates = [];
    for (let i = 0; i < coordinates.length; ++i) {
        newCoordinates.push(_convertPoint(coordinates[i], convertFunc));
    }

    return newCoordinates;
}

/**
 * 转换面几何坐标.
 * @param {Array} coordinates - 面的几何数组
 * @param {Function} convertFunc - 点坐标转换函数
 * @returns {Array} - 转换后的面几何数组
 */
function _convertPolygon(coordinates, convertFunc) {
    const newCoordinates = [];
    for (let i = 0; i < coordinates.length; ++i) {
        newCoordinates.push(_convertLineString(coordinates[i], convertFunc));
    }

    return newCoordinates;
}

/**
 * 转换多面几何坐标.
 * @param {Array} coordinates - 多面的几何数组
 * @param {Function} convertFunc - 点坐标转换函数
 * @returns {Array} - 转换后的多面几何数组
 */
function _convertMultiPolygon(coordinates, convertFunc) {
    const newCoordinates = [];
    for (let i = 0; i < coordinates.length; ++i) {
        newCoordinates.push(_convertPolygon(coordinates[i], convertFunc));
    }

    return newCoordinates;
}

/**
 * 遍历geojson对象，使用给定的方法转换坐标
 * 不会改变原对象
 * @param {Object}   geojson - 要转换的geoJson对象
 * @param {Function} convertFunc - 点坐标转换函数
 * @returns {Object} newGeojson - 转换后新的geoJson对象
 */
function convert(geojson, convertFunc) {
    const type = geojson.type;
    const newGeojson = {
        type: type
    };
    switch (type) {
        case 'Point':
            newGeojson.coordinates = _convertPoint(
                geojson.coordinates,
                convertFunc
            );
            break;
        case 'MultiPoint':
        case 'LineString':
            newGeojson.coordinates = _convertLineString(
                geojson.coordinates,
                convertFunc
            );
            break;
        case 'MultiLineString':
        case 'Polygon':
            newGeojson.coordinates = _convertPolygon(
                geojson.coordinates,
                convertFunc
            );
            break;
        case 'MultiPolygon':
            newGeojson.coordinates = _convertMultiPolygon(
                geojson.coordinates,
                convertFunc
            );
            break;
        case 'GeometryCollection':
            newGeojson.geometries = geojson.geometries.map(geometry => convert(geometry, convertFunc));
            break;
        default:
            throw new Error(`未知的几何类型:${type}`);
    }

    return newGeojson;
}

export default {
    convert
};
